import opportunities from '../config/opportunities';
import sectors from '../config/sectors';
import regions from '../config/regions';


export default {
	namespaced: true,
	state: {
		list: [],
		opportunity: {
			sector: {
				name: ''
			},
			region: {
				name: ''
			},
			center: []
		}
	},
	actions: {
		async getList({ commit }) {

			// TODO: query.name_like is a string search and can be added to more filters to work
			const sectorIdsToFilter = this.state.route.query.sectorId || []
			const filteredOpportunities = opportunities.opportunities
				.filter(opportunity => {
					return sectorIdsToFilter.includes(opportunity.sectorId);
				})

			const mappedOpportunities = filteredOpportunities.map(opportunity => {
				const sector = sectors.sectors.find(sector => sector.id === opportunity.sectorId);
				const region = regions.regions.find(region => region.id === opportunity.regionId);
				return {
					...opportunity,
					region,
					sector,
				};
			});
			commit('set', { type: 'list', value: mappedOpportunities })
		},
		async getOpportunity({ commit }, query) {
			const sectorIdsToFilter = this.state.route.query.sectorId

			if (sectorIdsToFilter === undefined) {
				return
			}
			const filteredOpportunities = opportunities.opportunities
				.filter(opportunity => {
					return sectorIdsToFilter.includes(opportunity.sectorId);
				})

			const mappedOpportunities = filteredOpportunities.map(opportunity => {
				const sector = sectors.sectors.find(sector => sector.id === opportunity.sectorId);
				const region = regions.regions.find(region => region.id === opportunity.regionId);
				return {
					...opportunity,
					region,
					sector,
				};
			});

			commit('set', { type: 'opportunity', value: mappedOpportunities[0] })
		}
	},
	mutations: {
		set(state, { type, value }) {
			state[type] = value
		}
	}
}
